// filepath: /Users/mihail/Developer/PorLaGloriaDeMiMadre/WebSites/x-perienc.es/website/creator-portal/frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App'; // Asumimos que tienes un componente App.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);